import recursiveWalk from './recursive-walk';

const applyJSONTemplates = (obj) => {
  // Only apply templates if they exist
  if (!('templates' in obj)) return obj;

  // Go through entire object looking for matches
  const regex = /{{template-([a-z0-9-_.]+)}}/;
  recursiveWalk(obj, (item, key, value) => {
    let newValue = value;
    let foundMatch = false;
    let match = regex.exec(newValue);
    while (match) {
      const slug = match[1];
      const replacement = obj?.templates?.[slug] || '';
      newValue = newValue.replace(`{{template-${slug}}}`, replacement);
      foundMatch = true;
      match = regex.exec(newValue);
    }

    // Save the new value
    if (foundMatch) {
      // eslint-disable-next-line no-param-reassign
      item[key] = newValue;
    }
  });

  // Return the adjusted object with templates removed
  // eslint-disable-next-line no-param-reassign
  delete obj.templates;
  return obj;
};

export default applyJSONTemplates;
